import uuid from 'uuid';
import { Callback } from '../types';

export type NotificationListenerCallbackType = (data: Callback) => void;

const callbacks = new Map<string, NotificationListenerCallbackType>();

export const addNotificationListenerCallback = (
  callback: NotificationListenerCallbackType
): string => {
  const ref = uuid.v4();
  callbacks.set(ref, callback);
  return ref;
};

export const removeNotificationListenerCallback = (ref: string) => {
  callbacks.delete(ref);
};

export const callNotificationListeners = (data: Callback) => {
  callbacks.forEach(fn => {
    fn(data);
  });
};
